import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=aa4e0876&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa4e0876')) {
      api.createRecord('aa4e0876', component.options)
    } else {
      api.reload('aa4e0876', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=aa4e0876&", function () {
      api.rerender('aa4e0876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Si36eypDqa1c/JS/comp/ImgFallback.vue"
export default component.exports